import React, { useState,useEffect,useContext } from 'react';
import QRCode from 'qrcode.react';
import {UserContex} from '../App'
import {Link, useNavigate,useParams,useLocation} from 'react-router-dom'
import SinglePage from './SinglePage';
import AdminHeader from '../components/AdminHeader';
import { Document, Page, Text, View, StyleSheet , PDFViewer,PDFDownloadLink,Image,pdf} from '@react-pdf/renderer';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SuperAdminHeader from '../components/SuperAdminHeader';

 
 
function SuperSingleEventsReport() {
    const {state, dispatch}= useContext(UserContex)

    const history = useNavigate()

  const [inputText, setInputText] = useState('');
  const [qrCodeText, setQRCodeText] = useState('');
  const [Zonedata,setZoneData] = useState([])
  const [data,setData] = useState([])
  const [ticketData,setTicketData] = useState([])
  const [ranked,setRanked] = useState([])
  const [rankedRevenue,setRankedRevenue] = useState([])
  const [total,setTotal] = useState(0)
  const [totalOccupied,setTotalOccupied] = useState(0)
  const [singleEvent,setSingleEvent] = useState(null)
  const [allEvents,setAllEvents] = useState(true)
  const [showsingleEvent,setShowSingleEvent] = useState(true)
  const [tickets,setTickets] = useState([])

  const [today,setToday] = useState(new Date())
  const[zone,setZone]= useState("")

  const [purchaseHistory, setPurchaseHistory] = useState({});
  const [demographics, setDemographics] = useState([]);
  const [activeCustomers, setActiveCustomers] = useState([]);
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState('All');
  const [sellerData, setSellerData] = useState([]);

  const location = useLocation();
  const {postid} = useParams()
  const item = location.state?.item;


useEffect(() => {
  

    fetch(`/findeventsticketsuper/${postid}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt")
      }
    })
      .then(res => res.json())
      .then(result => {
        const tickets = result.tickets;
        setTicketData(tickets);

     
      })
      .catch(err => console.error(err));





}, []);

const handleEventChange = (e) => {
  setSelectedEvent(e.target.value);
};

const filteredTickets = selectedEvent === 'All'
  ? ticketData
  : ticketData.filter(ticket => ticket.event.name === selectedEvent);


 
  const singlEvent = (Itemid)=>{

    fetch(`/getsingleevent/${Itemid}`,{
      method:"get",
      headers:{
        Authorization: "Bearer " +localStorage.getItem("jwt"),
        "Content-Type":"application/json"
  
      }
  }).then(res=>res.json())
  .then(result=>{
  


    setSingleEvent(result.event)
    // setAllEvents(false)
            
  })


    fetch(`/findeventsticket/${Itemid}`,{
      method:"get",
      headers:{
        Authorization: "Bearer " +localStorage.getItem("jwt"),
        "Content-Type":"application/json"
  
      }
  }).then(res=>res.json())
  .then(result=>{
  


    setTickets(result.tickets)

            
  })



  
  }
    


  const PrintSales = (da) => (

    <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
      <Image style={styles.logo} src="/logo.png"
   />
  
        <Text style={styles.address}>Customers for {singleEvent.name}</Text>
        <Text style={{fontSize:10, marginBottom: 3}}>Venue: {singleEvent.venue}</Text>
      
      </View>
      <View style={styles.horizontalLine} />
  
      <View style={styles.invoiceDetails}>
        <View style={styles.itemList}>
          <View style={styles.itemRow}>
            <Text style={styles.label}>Name</Text>
            <Text style={styles.label}>Ticket No</Text>
          </View>
          <View style={styles.horizontalLine} />
  
          {tickets.map((item, index) => (
            <View>
  
            <View key={index} style={styles.itemRow}>
              <Text style={styles.itemDescription}>{item.name}</Text>
              <Text style={styles.itemDescription}>{item._id.slice(-4)}</Text>
              {/* <Text style={styles.itemDescription}>{item.qty}</Text> */}
              {/* <Text style={styles.itemDescription}>{item.amount.toFixed(0)}</Text> */}
            </View>
            <View style={styles.horizontalLine} />
  
            </View>
  
            
          ))}
  
        </View>
  
        <View style={styles.totalRow}>
          <Text style={styles.totalLabel}>Total: {tickets.length}</Text>
          {/* <Text style={styles.totalValue}>{invoice.total}</Text> */}
        </View>
        <View style={styles.horizontalLine} />
  
      </View>
    </Page>
  </Document>
    
  );


  const PrintOccupancy = (da) => (

    <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
      <Image style={styles.logo} src="/logo.png"
   />
  
        <Text style={styles.address}>Occupancy Report</Text>
        {/* <Text style={{fontSize:10, marginBottom: 3}}>Venue: {singleEvent.venue}</Text> */}
      
      </View>
      <View style={styles.horizontalLine} />
  
      <View style={styles.invoiceDetails}>
        <View style={styles.itemList}>
          <View style={styles.itemRow}>
            <Text style={styles.label}>Event</Text>
            <Text style={styles.label}>Occupancy</Text>
          </View>
          <View style={styles.horizontalLine} />
  
          {ranked.map((item, index) => (
            <View>
  
            <View key={index} style={styles.itemRow}>
              <Text style={styles.itemDescription}>{item.name}</Text>
              <Text style={styles.itemDescription}>{item.occupied}</Text>
              {/* <Text style={styles.itemDescription}>{item.qty}</Text> */}
              {/* <Text style={styles.itemDescription}>{item.amount.toFixed(0)}</Text> */}
            </View>
            <View style={styles.horizontalLine} />
  
            </View>
  
            
          ))}
  
        </View>
  
        <View style={styles.totalRow}>
          <Text style={styles.totalLabel}>Total: {totalOccupied}</Text>
          {/* <Text style={styles.totalValue}>{invoice.total}</Text> */}
        </View>
        <View style={styles.horizontalLine} />
  
      </View>
    </Page>
  </Document>
    
  );


  const PrintRevenew = (da) => (

    <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
      <Image style={styles.logo} src="/logo.png"
   />
  
        <Text style={styles.address}>Revenew Report</Text>
        {/* <Text style={{fontSize:10, marginBottom: 3}}>Venue: {singleEvent.venue}</Text> */}
      
      </View>
      <View style={styles.horizontalLine} />
  
      <View style={styles.invoiceDetails}>
        <View style={styles.itemList}>
          <View style={styles.itemRow}>
            <Text style={styles.label}>Event</Text>
            <Text style={styles.label}>Amount</Text>
          </View>
          <View style={styles.horizontalLine} />
  
          {rankedRevenue.map((item, index) => (
            <View>
  
            <View key={index} style={styles.itemRow}>
              <Text style={styles.itemDescription}>{item.name}</Text>
              <Text style={styles.itemDescription}>{item.occupied*item.price}</Text>
              {/* <Text style={styles.itemDescription}>{item.qty}</Text> */}
              {/* <Text style={styles.itemDescription}>{item.amount.toFixed(0)}</Text> */}
            </View>
            <View style={styles.horizontalLine} />
  
            </View>
  
            
          ))}
  
        </View>
  
        <View style={styles.totalRow}>
          <Text style={styles.totalLabel}>Total: {total}</Text>
          {/* <Text style={styles.totalValue}>{invoice.total}</Text> */}
        </View>
        <View style={styles.horizontalLine} />
  
      </View>
    </Page>
  </Document>
    
  );



  const PrintSellerDetail = (da) => (

    <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
      <Image style={styles.logo} src="/logo.png"
   />
  
        <Text style={styles.address}>Sellers Report</Text>
        {/* <Text style={{fontSize:10, marginBottom: 3}}>Venue: {singleEvent.venue}</Text> */}
      
      </View>
      <View style={styles.horizontalLine} />
  
      <View style={styles.invoiceDetails}>
        <View style={styles.itemList}>
          <View style={styles.itemRow}>
            <Text style={styles.label}>Name</Text>
            <Text style={styles.label}>Event</Text>
            <Text style={styles.label}>Nos. Sold</Text>
          </View>
          <View style={styles.horizontalLine} />
  
          {sellerData.map((item, index) => (
            <View>
  
            <View key={index} style={styles.itemRow}>
              <Text style={styles.itemDescription}>{item.name}</Text>
              <Text style={styles.itemDescription}>{item.event}</Text>
              <Text style={styles.itemDescription}>{item.count}</Text>
              {/* <Text style={styles.itemDescription}>{item.qty}</Text> */}
              {/* <Text style={styles.itemDescription}>{item.amount.toFixed(0)}</Text> */}
            </View>
            <View style={styles.horizontalLine} />
  
            </View>
  
            
          ))}
  
        </View>
  
  
      </View>
    </Page>
  </Document>
    
  );
  
  function exportToExcel(data) {
    // Convert data to CSV format
    const formattedData = tickets.map(({ name, _id }) => [name, _id.slice(-4)]);
  
    // Add headers to the CSV string
    const csv = [['Name', 'Ticket No']].concat(formattedData.map(row => row.join(','))).join('\n');
  
    // Create a Blob containing the CSV data
    const blob = new Blob([csv], { type: 'text/csv' });
  
    // Create a temporary URL for the Blob
    const url = window.URL.createObjectURL(blob);
  
    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${"Ticket "+singleEvent.name+" Report"}.csv`);
  
    // Append the link to the DOM and click it programmatically
    document.body.appendChild(link);
    link.click();
  
    // Clean up: remove the link and revoke the URL
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
  
  const styles = StyleSheet.create({
    page: {
      fontFamily: 'Helvetica',
      padding: 30,
    },
    header: {
      marginBottom: 2,
      justifyContent: 'center',
      alignItems: 'center',
    },
    title: {
      fontSize: 20,
      fontWeight: 'bold',
      marginBottom: 10,
    },
    address: {
      fontSize: 12,
      marginBottom: 10,
    },
    invoiceDetails: {
      marginBottom: 20,
    },
    label: {
      fontSize: 15,
      fontWeight: 'bold',
    },
    labelfooter: {
      fontSize: 10,
      fontWeight: 'bold',
      marginBottom: 8,
      marginTop: 8,
  
    },
    value: {
      fontSize: 12,
    },
    itemList: {
      marginTop: 2,
    },
    itemRow: {
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      marginBottom: 8,
      marginLeft:8
    },
    itemDescription: {
      width: '20%',
      textAlign:'center',
      fontSize:12
  
    },
    itemQuantity: {
      width: '15%',
      textAlign: 'left',
    },
    itemAmount: {
      width: '25%',
      textAlign: 'right',
    },
    totalRow: {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      marginTop: 10,
    },
    totalLabel: {
      fontSize: 14,
      fontWeight: 'bold',
    },
    totalValue: {
      fontSize: 14,
      marginLeft: 10,
    },
    logo: {
      width: 80, 
      height: 80, 
      marginBottom: 10,
      justifyContent: 'center',
      alignItems: 'center',  },
  
  
    horizontalLine: {
      borderTop: 1,
      borderColor: 'black',
      marginVertical: 4,
      width: '100%',
    },
  });
  


  const renderPDF = (type, info) => {
    switch (type) {
      case 'sales':
        return <PrintSales  />;
      case 'PrintOccupancy':
        return <PrintOccupancy  />;
      case 'PrintRevenew':
        return <PrintRevenew  />;
      case 'PrintSellerDetail':
        return <PrintSellerDetail  />;
      default:
        return null;
    }
  };
  
  
  // Function to send PDF Blob to the backend
  // Function to send PDF Blob to the backend using fetch
  const sendPDFToBackend = async (type,info) => {
    try {
      // Generate the PDF as a Blob
      // const blob = await pdf(<PrintAllVotes />).toBlob();
      const blob = await pdf(renderPDF(type,info)).toBlob();
  
  
      // Create FormData to append the PDF Blob
      const formData = new FormData();
      formData.append('file', blob, `${type}.pdf`);
  
      // Send the Blob to your backend using fetch
      const response = await fetch('/sendvaimail', {
        method: 'POST',
        headers:{
          Authorization: "Bearer " +localStorage.getItem("jwt")
  
        },
        body: formData,
      });
  
      if (response.ok) {
        const result = await response.json();
        toast.success("We have mailed you the Report")

        console.log('PDF successfully uploaded:', result);
      } else {
        console.error('Error uploading the PDF:', response.statusText);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

//   console.log("Sinvle"singleEvent.seats)

  const Logout = ()=>{
    localStorage.clear()
    dispatch({type:"CLEAR"})
        history(`/login`)
}
 
  return (

    <>



        <main class="relative h-screen overflow-auto bg-gray-100  rounded-2xl">
        <SuperAdminHeader></SuperAdminHeader>

        <div className='grid md:grid-cols-4 grid-cols-1 mt-2 justify-items-normal '>

<div class="flex flex-col    max-w-xl gap-4 p-4 bg-white shadow-xl rounded-xl dark:bg-gray-800 md:flex-row">
    <div class="relative">
        <img src={item.pic?item.pic:"https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&q=80&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&w=1470"}  class="w-full rounded-xl md:w-auto md:max-h-40"/>
        <span class="absolute px-2 py-1 text-xs text-white rounded bg-gray-700/50 right-2 bottom-2">
          
        </span>
    </div>
    <div class="flex flex-col justify-between">
        <div class="flex items-start justify-between my-2 text-gray-700 dark:text-white md:m-0">
            <p class="text-xl leading-5">
                {item.name}
            </p>
            {/* <button class="text-red-400 hover:text-red-600">
                <svg width="25" height="25" fill="currentColor" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1664 596q0-81-21.5-143t-55-98.5-81.5-59.5-94-31-98-8-112 25.5-110.5 64-86.5 72-60 61.5q-18 22-49 22t-49-22q-24-28-60-61.5t-86.5-72-110.5-64-112-25.5-98 8-94 31-81.5 59.5-55 98.5-21.5 143q0 168 187 355l581 560 580-559q188-188 188-356zm128 0q0 221-229 450l-623 600q-18 18-44 18t-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344z">
                    </path>
                </svg>
            </button> */}
        </div>
        <div class="flex items-center my-2 text-xs text-gray-500 dark:text-gray-400 md:m-0">
            <svg width="10" height="10" fill="currentColor" class="mr-2" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                <path d="M1664 960q-152-236-381-353 61 104 61 225 0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-121 61-225-229 117-381 353 133 205 333.5 326.5t434.5 121.5 434.5-121.5 333.5-326.5zm-720-384q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zm848 384q0 34-20 69-140 230-376.5 368.5t-499.5 138.5-499.5-139-376.5-368q-20-35-20-69t20-69q140-229 376.5-368t499.5-139 499.5 139 376.5 368q20 35 20 69z">
                </path>
            </svg>
            {item.seats} Seats
            <svg width="10" height="10" fill="currentColor" class="ml-6 mr-2" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                <path d="M896 1664q-26 0-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344q0 221-229 450l-623 600q-18 18-44 18z">
                </path>
            </svg>
          {item.venue}
        </div>
        <div class="flex items-start my-2 md:m-0">
            <div class="relative">
                <a href="#" class="relative block">
                    <img alt="profil" src={item.pic?item.pic:"https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&q=80&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&w=1470"}  class="mx-auto object-cover rounded-full h-10 w-10 "/>
                </a>
                <svg width="10" height="10" fill="currentColor" class="absolute bottom-0 right-0 w-4 h-4 p-1 -mx-1 -my-1 text-white bg-blue-600 rounded-full fill-current" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z">
                    </path>
                </svg>
            </div>
            {/* <div class="flex flex-col items-start justify-center ml-2">
                <span class="flex items-center text-sm text-gray-600 dark:text-gray-200">
                    Charlie Rabiller
                    <span class="block w-2 h-2 ml-1 bg-green-500 rounded-full">
                    </span>
                </span>
                <span class="text-xs text-gray-400">
                    1 week ago
                </span>
            </div> */}
        </div>
    </div>
</div>

  <div class="p-4 bg-white shadow-lg rounded-2xl dark:bg-gray-800 ml-2">
    <div class="flex items-center">
        <span class="relative p-4 bg-purple-200 rounded-xl">
            <svg width="40" fill="currentColor" height="40" class="absolute h-4 text-purple-500 transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                <path d="M1362 1185q0 153-99.5 263.5t-258.5 136.5v175q0 14-9 23t-23 9h-135q-13 0-22.5-9.5t-9.5-22.5v-175q-66-9-127.5-31t-101.5-44.5-74-48-46.5-37.5-17.5-18q-17-21-2-41l103-135q7-10 23-12 15-2 24 9l2 2q113 99 243 125 37 8 74 8 81 0 142.5-43t61.5-122q0-28-15-53t-33.5-42-58.5-37.5-66-32-80-32.5q-39-16-61.5-25t-61.5-26.5-62.5-31-56.5-35.5-53.5-42.5-43.5-49-35.5-58-21-66.5-8.5-78q0-138 98-242t255-134v-180q0-13 9.5-22.5t22.5-9.5h135q14 0 23 9t9 23v176q57 6 110.5 23t87 33.5 63.5 37.5 39 29 15 14q17 18 5 38l-81 146q-8 15-23 16-14 3-27-7-3-3-14.5-12t-39-26.5-58.5-32-74.5-26-85.5-11.5q-95 0-155 43t-60 111q0 26 8.5 48t29.5 41.5 39.5 33 56 31 60.5 27 70 27.5q53 20 81 31.5t76 35 75.5 42.5 62 50 53 63.5 31.5 76.5 13 94z">
                </path>
            </svg>
        </span>
        <p class="ml-2 text-black text-md dark:text-white">
            Total Tickets
        </p>
    </div>
    <div class="flex flex-col justify-start">
        <p class="my-4 text-4xl font-bold text-left text-gray-700 dark:text-gray-100">
           {ticketData.length}
            
        </p>
        {/* <div class="flex items-center text-sm text-green-500">
            <svg width="20" height="20" fill="currentColor" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                <path d="M1408 1216q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z">
                </path>
            </svg>
            <span>
                5.5%
            </span>
            <span class="text-gray-400">
                vs last month
            </span>
        </div> */}
    </div>
</div>
  <div class="p-4 bg-white shadow-lg rounded-2xl dark:bg-gray-800 ml-2">
    <div class="flex items-center">
        <span class="relative p-4 bg-purple-200 rounded-xl">
            <svg width="40" fill="currentColor" height="40" class="absolute h-4 text-purple-500 transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                <path d="M1362 1185q0 153-99.5 263.5t-258.5 136.5v175q0 14-9 23t-23 9h-135q-13 0-22.5-9.5t-9.5-22.5v-175q-66-9-127.5-31t-101.5-44.5-74-48-46.5-37.5-17.5-18q-17-21-2-41l103-135q7-10 23-12 15-2 24 9l2 2q113 99 243 125 37 8 74 8 81 0 142.5-43t61.5-122q0-28-15-53t-33.5-42-58.5-37.5-66-32-80-32.5q-39-16-61.5-25t-61.5-26.5-62.5-31-56.5-35.5-53.5-42.5-43.5-49-35.5-58-21-66.5-8.5-78q0-138 98-242t255-134v-180q0-13 9.5-22.5t22.5-9.5h135q14 0 23 9t9 23v176q57 6 110.5 23t87 33.5 63.5 37.5 39 29 15 14q17 18 5 38l-81 146q-8 15-23 16-14 3-27-7-3-3-14.5-12t-39-26.5-58.5-32-74.5-26-85.5-11.5q-95 0-155 43t-60 111q0 26 8.5 48t29.5 41.5 39.5 33 56 31 60.5 27 70 27.5q53 20 81 31.5t76 35 75.5 42.5 62 50 53 63.5 31.5 76.5 13 94z">
                </path>
            </svg>
        </span>
        <p class="ml-2 text-black text-md dark:text-white">
            Total Amount
        </p>
    </div>
    <div class="flex flex-col justify-start">
        <p class="my-4 text-4xl font-bold text-left text-gray-700 dark:text-gray-100">
           $ {ticketData.length*item.price}
            
        </p>
        {/* <div class="flex items-center text-sm text-green-500">
            <svg width="20" height="20" fill="currentColor" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                <path d="M1408 1216q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z">
                </path>
            </svg>
            <span>
                5.5%
            </span>
            <span class="text-gray-400">
                vs last month
            </span>
        </div> */}
    </div>
</div>

</div>
    

<div class="container max-w-3xl px-4 mx-auto sm:px-8">
    <div class="py-8">
        <div class="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
            <div class="inline-block min-w-full overflow-hidden rounded-lg shadow">
                <table class="min-w-full leading-normal">
                    <thead>
                        <tr>
                            <th scope="col" class="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200">
                                Name
                            </th>
                            <th scope="col" class="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200">
                                Email
                            </th>
                            <th scope="col" class="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200">
                               Phone
                            </th>
                            <th scope="col" class="px-5 py-3 text-sm font-normal text-left text-gray-800 uppercase bg-white border-b border-gray-200">
                                status
                            </th>
                        </tr>
                    </thead>
                    <tbody>

                      {ticketData.length>0?
                      ticketData.map(items=>{
                        return(
                          <tr>
                          <td class="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <div class="flex items-center">
                                 
                                  <div class="">
                                      <p class="text-gray-900 whitespace-no-wrap">
                                          {items.name}
                                      </p>
                                  </div>
                              </div>
                          </td>
                          <td class="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <p class="text-gray-900 whitespace-no-wrap">
                              {items.email}
                              </p>
                          </td>
                          <td class="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <p class="text-gray-900 whitespace-no-wrap">
                              {items.phone}

                              </p>
                          </td>
                          <td class="px-5 py-5 text-sm bg-white border-b border-gray-200">
                              <span class="relative inline-block px-3 py-1 font-semibold leading-tight text-green-900">
                                  <span aria-hidden="true" class="absolute inset-0 bg-green-200 rounded-full opacity-50">
                                  </span>
                                  <span class="relative">
                                  {items.status}

                                  </span>
                              </span>
                          </td>
                      </tr>
                        )
                      })
                      :<></>}
                      
                     
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

                                               
                               
       
    </main>


    

    </>
    
  );
}
 
export default SuperSingleEventsReport;